import { Component, inject, Input } from '@angular/core';
import { Card } from "primeng/card";
import { TranslatePipe } from "@ngx-translate/core";
import { RouterLink } from "@angular/router";
import { LazyRouteLoadingService } from '@services/lazy-route-loading.service';

export interface ISummaryItem {
    icon: string;
    title: string;
    url: string;
    queryParams?: { [key: string]: any };
    iconBack?: string;
    iconClass?: string;
    cardStyle?: Partial<CSSStyleDeclaration>;
    onlySideMenu?: boolean;
    iconFill?:string;
    iconStroke?:string;
}

@Component({
    selector: 'msf-summary-items-list',
    imports: [
        Card,
        TranslatePipe,
        RouterLink
    ],
    templateUrl: './summary-items-list.html',
    styleUrl: './summary-items-list.scss',
    standalone: true
})
export class SummaryItemsList {
    private readonly lazyRouteLoading = inject(LazyRouteLoadingService);

    @Input() items: ISummaryItem[] = [];

    onMenuClick(url: string): void {
        this.lazyRouteLoading.onMenuItemClick(url);
    }
}
